import React from "react";
import { useTranslation } from "react-i18next";
import { IonIcon, IonSkeletonText } from "@ionic/react";
import { close } from "ionicons/icons";

const ProductDetailSheetSkeleton = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col justify-center gap-4">
        <div className="w-full rounded-md">
          <div className="flex items-center justify-end px-4 pt-1 cursor-pointer">
            <IonIcon icon={close} size="small" />
          </div>
          <div className="w-full h-64 flex items-center justify-center">
            <IonSkeletonText animated style={{ width: "90%", height: "90%" }} />
          </div>
        </div>
        <div className="flex flex-col items-start justify-start gap-2 px-4">
          <div className="flex flex-col justify-between gap-3 w-full pb-3 border-b border-[#f2f2f2]">
            <div className="flex flex-col items-start justify-center text-lg leading-5 w-full">
              <IonSkeletonText animated style={{ width: "70%", height: "20px" }} />
              <IonSkeletonText animated style={{ width: "40%", height: "16px" }} />
            </div>
            <IonSkeletonText animated style={{ width: "32%", height: "30px", borderRadius: "9999px" }} />
          </div>

          <div className="flex flex-col justify-between gap-3 w-full pb-3 border-b border-[#f2f2f2]">
            <h3 className="font-bold">{t("Product Description")}</h3>
            <IonSkeletonText animated style={{ width: "100%", height: "80px" }} />
          </div>

          <div className="flex flex-col justify-between gap-3 w-full pb-3 border-b border-[#f2f2f2]">
            <h3 className="font-bold">{t("Price")}</h3>
            <IonSkeletonText animated style={{ width: "30%", height: "24px" }} />
          </div>

          <div className="flex flex-col justify-between gap-3 w-full pb-3 border-b border-[#f2f2f2]">
            <h3 className="font-bold">{t("Quantity")}</h3>
            <IonSkeletonText animated style={{ width: "50%", height: "16px" }} />
          </div>

          <div className="flex w-full pt-3">
            <IonSkeletonText animated style={{ width: "100%", height: "44px", borderRadius: "8px" }} />
          </div>
        </div>
      </div>
      <div className="my-4 px-4">
        <h3 className="font-bold mb-2">{t("Products of this category")}</h3>
        <div className="flex overflow-x-auto gap-3">
          {[1, 2, 3].map((item) => (
            <div key={item} className="min-w-[120px] flex-shrink-0">
              <IonSkeletonText animated style={{ width: "100%", height: "120px", borderRadius: "8px" }} />
              <IonSkeletonText animated style={{ width: "80%", height: "16px", marginTop: "8px" }} />
              <IonSkeletonText animated style={{ width: "60%", height: "14px", marginTop: "4px" }} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ProductDetailSheetSkeleton;
